import { useQuery } from '@tanstack/react-query';
import type { Dispatch, SetStateAction } from 'react';

import { CenterFlex } from '@/components/base';
import Spinner from '@/components/Common/Spinner';
import Transition from '@/components/Common/Transition';
import queryKeys from '@/configs/react-query-keys';
import service from '@/services/index';
import type { FilterItemsEmailT } from '@/types/filterItems';

import FilterItemsEmail from './FilterItemsEmail';

type FilterItemsImportingEmailTabProps = {
  setHasEmailTabChange: Dispatch<SetStateAction<boolean>>;
};

const FilterItemsImportingEmailTab = (
  props: FilterItemsImportingEmailTabProps,
) => {
  const { data: filterItemsEmail, isLoading: isFilterItemsEmailLoading } =
    useQuery({
      queryKey: queryKeys.filterItems.FILTER_ITEMS_IMPORT_EMAIL,
      queryFn: service.filterItems.fetchImportFilterEmails,
    });

  const onSaveChange = async ({
    addedEmails,
    deletedEmails,
    addedEmailDomains,
    deletedEmailDomains,
  }: {
    addedEmails: string[];
    deletedEmails: string[];
    addedEmailDomains: string[];
    deletedEmailDomains: string[];
  }): Promise<FilterItemsEmailT> => {
    const decapitalizedAddedEmails = addedEmails.map((email) =>
      email.toLowerCase(),
    );
    const decapitalizedAddedEmailDomains = addedEmailDomains.map(
      (emailDomain) => emailDomain.toLowerCase(),
    );
    const decapitalizedDeletedEmails = deletedEmails.map((email) =>
      email.toLowerCase(),
    );
    const decapitalizedDeletedEmailDomains = deletedEmailDomains.map(
      (emailDomain) => emailDomain.toLowerCase(),
    );

    try {
      const data = await service.filterItems.changeImportingFilterEmails({
        added_emails: decapitalizedAddedEmails,
        deleted_emails: decapitalizedDeletedEmails,
        added_email_domains: decapitalizedAddedEmailDomains,
        deleted_email_domains: decapitalizedDeletedEmailDomains,
      });

      return data;
    } catch (e) {
      throw e;
    }
  };

  return (
    <Transition
      status={!isFilterItemsEmailLoading}
      fallback={
        <CenterFlex height="100%">
          <Spinner />
        </CenterFlex>
      }
    >
      <FilterItemsEmail
        data={filterItemsEmail}
        onSaveChange={onSaveChange}
        setHasEmailTabChange={props.setHasEmailTabChange}
      />
    </Transition>
  );
};

export default FilterItemsImportingEmailTab;
